module.exports = __webpack_public_path__ + "static/media/eeg.92c605a3.pdf";